// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LenderInfo_wrapper__2xYtc","name":"LenderInfo_name__1JsMq","logo":"LenderInfo_logo__2-n3I"};